// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2oMou","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2ae_H"};